import { Link } from 'react-router-dom';

const DashCountDetail = ({ link, title, caption, value, cardType }) => {
  return (
    <div className="card dash-count-card">
      <div className="card-body">
        <div className="dash-card-wrap">
          <div className="card-count-info">
            <p className="card-title title">{title}</p>
            {caption && <p className="card-title caption">{caption}</p>}
          </div>
          <div className="card-count-value">
            {link ? (
              <p>
                <Link to={link} className="link-text">
                  {value}
                </Link>
              </p>
            ) : (
              <p>{value}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashCountDetail;
